<!--官方号列表-->
<template>
  <div class="official-number-container">
    <header-index/>
    <div class="official-number-content">
      <div class="official-number-top">
        <div class="bigger-li">
          <span>全部官方号</span>
          <div class="small-li" v-if="CustomInfo.status!=1">
            <el-button class="el-official-button" @click="enterpriseCertification">加入官方号</el-button>
          </div>
        </div>
      </div>
      <div class="official-number-info">
        <div class="official-list" v-if="officialNumberInfo.length>0">
          <el-row :gutter="24">
            <template v-for="follow of officialNumberInfo">
              <el-col :span="12">
                <div class="official-list-li" @click="authorPage(follow)">
                  <div class="official-logo">
                    <el-image class="official-img" :src="follow.avatar" fit="contain"/>
                    <i class="official-icon">官</i>
                  </div>
                  <div class="official-right">
                    <p class="user-name">{{ follow.name }}</p>
                    <p class="type-introduction" v-if="follow.introduction">{{ follow.introduction }}</p>
                    <p class="type-name">
                      <span class="el-danger" v-if="follow.province"><i class="el-icon-location"
                                                                        style="padding-right: 10px;"/>{{
                          follow.province
                        }}</span>
                      <span class="el-normal" v-if="follow.industry">{{ follow.industry }}</span>
                    </p>
                  </div>
                </div>
              </el-col>
            </template>
          </el-row>
          <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
                :limit="tablePage.pageSize" style="padding: 20px 25px 15px 10px;"/>
        </div>
        <div class="official-list" v-else>
          <el-empty description="暂无官方号"/>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import {officialNumberList} from '@/api/interfaceApi'
import page from "@/components/page/pages";

export default {
  name: "officialNumberAll",
  components: {Hang, Home_footer, HeaderIndex, page},
  data() {
    return {
      cid: 0,
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      officialNumberInfo: [],
      CustomInfo: {}
    }
  },
  methods: {
    /*获取官方号列表*/
    getOfficialNumberList() {
      officialNumberList({
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        uid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = res.content.total;
          this.officialNumberInfo = res.content.rows;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getOfficialNumberList(this.page);
    },
    /*官方号详情*/
    authorPage(row) {
      let routeData = this.$router.resolve({
        name: "officialNumberDetails",
        path: '/officialCloud/officialNumberDetails',
        query: {
          id: row.cid
        }
      });
      window.open(routeData.href, '_blank')
    },
    /*企业认证*/
    enterpriseCertification() {
      if (JSON.stringify(this.CustomInfo) == '{}') {
        this.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.replace({
              path: '/login'
            })
          }
        })
      } else {
        let routeData = this.$router.resolve({
          name: "enterpriseCertification",
          path: '/officialCloud/enterpriseCertification',
        });
        window.open(routeData.href, '_blank')
      }
    },
  },
  mounted() {
    this.getOfficialNumberList();
  },
  beforeMount() {
    this.CustomInfo = sessionStorage.getItem('CustomInfo') ? JSON.parse(sessionStorage.getItem('CustomInfo')) : {};
    this.cid = sessionStorage.getItem('CustomInfo') ? JSON.parse(sessionStorage.getItem('CustomInfo')).cid : 0;
  }
}
</script>
<style scoped lang="scss">
.official-number-container {
  background: #ffffff;

  .official-number-content {
    .official-number-top {
      background: url("~@/assets/img/enterprise/officialNumberAll.png") no-repeat;
      height: 330px;
      padding: 0px 18%;
      background-size: 100% 100%;
      text-align: center;
      display: flex;
      align-items: center;
      cursor: pointer;
      min-width: 76rem;
      justify-content: center;

      .bigger-li {
        font-size: 48px;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        letter-spacing: 10px;
        color: #FFFFFF;

        .el-official-button {
          color: #2534B4;
          font-size: 14px;
          margin-top: 20px;
          font-family: "Microsoft YaHei";
          font-weight: bold;
        }
      }
    }

    .official-number-info {
      padding: 20px 18%;
      min-width: 76rem;
      background: #ffffff;

      .official-list {
        .official-list-li {
          display: flex;
          justify-content: left;
          align-items: flex-start;
          margin-bottom: 20px;
          min-height: 105px;

          .official-logo {
            .official-icon {
              position: absolute;
              font-size: 12px;
              background: #1637FF;
              color: #ffffff;
              font-style: normal;
              padding: 2px 5px;
              border-radius: 50%;
              margin-top: 40px;
              margin-left: -15px;
            }

            .official-img {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              border: 1px solid #d1d1d1;
            }
          }

          .official-right {
            padding: 10px 0px 10px 15px;

            p {
              margin-block-end: 0px;
              margin-block-start: 0px;
            }

            .user-name {
              font-size: 18px;
              color: #333333;
              font-family: 'SourceHanSansCN';
            }

            .type-name {
              font-size: 14px;
              font-family: "SourceHanSansCN";
              margin-block-start: 10px;

              .el-danger {
                background: #FFE7E9;
                padding: 10px;
                color: #FE273B;
                border-radius: 6px;
              }

              .el-normal {
                background: #EBEEFF;
                padding: 10px;
                border-radius: 6px;
                color: #1637FF;
                margin-left: 10px;
              }
            }

            .type-introduction {
              font-size: 14px;
              color: #999999;
              font-family: "SourceHanSansCN";
              margin-block-start: 5px;
              margin-block-end: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
</style>